module.exports = __webpack_public_path__ + "img/filter-welcome-background.f6dc7307.png";